import setHours from "date-fns/fp/setHours";
import setMinutes from "date-fns/fp/setMinutes";
import compose from "lodash/fp/compose";

const setDateTime = (date: Date, time?: string | null) => {
  const [hours, minutes] = time
    ?.split(":")
    .map((value) => Number.parseInt(value, 10)) || [0, 0];

  return compose(setHours(hours), setMinutes(minutes))(date);
};

export default setDateTime;
